export { View as ViewEventPage } from './View';
